import React from "react"
import Header from "./header"
import Toolbar from '@mui/material/Toolbar'

//mui v5
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Box } from '@mui/material';

//下部スペース用(drawer-bottomが表示されるとスクロールしきれないのでスペースを作る)
import SpacingBox from './spacing_box.js'

//コンポーネント
import DrawerComponent from './drawer.js'

const drawerWidth = 300;

const Layout = ({ children, selected_category,
  //メモ：gatsby head api移行に伴いLayoutからSEOは除去。各ページで読み込むこと。合わせて次の変数も不要に
  // , postTitle, postDescription, authorId, imagePath, noIndex,
}) => {
  let theme = useTheme()
  
  //ドロワのオープン状態を切り替えるメソッド
  const setMobileOpen = theme.status?.setMobileOpen
  //初回入場かどうかを切り替えるメソッド
  const setFirstEnter = theme.status?.setFirstEnter
  const isFirstEnter = theme.status?.isFirstEnter.current //useRef(値変化で再描画しない)を使用しているので、currentで値を取る

  //ドロワのオープン状態を設定するスイッチ
  const mobileOpen = theme.status?.mobileOpen

  //このデスクトップ判定は画面が読み込んでからになる(判定が遅い)が
  //モバイルで初回入場時に一時的に非表示になっているのでその間にドロワを引っ込めるために必要
  const isDesktop = useMediaQuery((theme) =>
    theme.breakpoints.up('md'), { noSsr: true }
  );

  //チラツキめも
  //現状ロードした直後に2回レンダされるのは謎
  //レイアウトすらよまないtestaaだけでも2回イメージがレンダされてしまう
  //useEffect等やあらゆるコンポーネントをオフにしても関係ない模様
  //sharpの不具合か？fireFoxだと発生しない
  React.useEffect(() => {
    //初めて入ってきたときのドロワ初期値を切り替え
    if (isFirstEnter) {
      setMobileOpen(isDesktop)
      setFirstEnter(false)
    } else {
      //別ページへ移動した時
      if (isDesktop) {
        //デスクトップの時だけドロワ状態を継続
        //モバイルのときは問答無用で一旦ひっこめないとドロワが邪魔で記事が読めない
        setMobileOpen(mobileOpen)
      }
    }

  }, [isDesktop, isFirstEnter, setFirstEnter, setMobileOpen, mobileOpen])

  //おそらく最初にロード画面を出しているせいでアンカーに飛べないので後からアンカーへスクロールする処理。
  React.useEffect(() => {
    if (window.location.hash && !isFirstEnter) {
      const hashSave = window.location.hash
      window.location.hash = ""
      window.location.hash = hashSave
    }
  }, [isFirstEnter])

  return (

    <>
      <header>
        <Header
          mobileOpen={mobileOpen}
          setMobileOpen={setMobileOpen}
          selected_category={selected_category}
        />
      </header>
      <Toolbar />

      {/* sxのレスポンシブ対応は次
      https://mui.com/system/getting-started/usage/#responsive-values */}
      <Box sx={{
        flexGrow: 1,
        paddingTop: theme.spacing(2),
        // padding: isDesktop ? theme.spacing(2) : "",
        padding: { md: theme.spacing(2) },
        ...(mobileOpen && {
          marginLeft: { md: `${drawerWidth}px` }
        }),
      }}>

        {/* 重要：childrenをブロックするとスコアが大幅に下るのでこれは非表示にしないこと */}
        {children}
      </Box>

      {/* ドロワ */}
      {/* 最初の入場 > モバイルのみ一旦非表示 */}
      <Box sx={{
        ...(isFirstEnter && {
          display: ["none", "none", "block"],
        }),
      }} >
        <DrawerComponent
          setMobileOpen={setMobileOpen}
          mobileOpen={mobileOpen}
          selected_category={selected_category}
        />
      </Box>

      {/* 下部広告が表示されているときに隠れてしまうのでページを引き伸ばす */}
      <SpacingBox theme={theme} />
    </>
  )
}

export default Layout

